export default __webpack_public_path__ + "static/media/connect.8d9b6ab3.png";